module.exports = __webpack_public_path__ + "static/img/rgba.f13722d9.png";